import { render, staticRenderFns } from "./BranchRoleInfo.vue?vue&type=template&id=566caeaf&scoped=true&"
import script from "./BranchRoleInfo.vue?vue&type=script&lang=js&"
export * from "./BranchRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566caeaf",
  null
  
)

export default component.exports